import {
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";

export default function ReportLoading({
  text = "Loading report...",
}) {
  return (
    <Box
      py={8}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
    >
      <CircularProgress />

      <Typography>{text}</Typography>
    </Box>
  );
}